(function () {
    if (typeof Promise.withResolvers !== 'function') {
        Promise.withResolvers = function () {
            let resolve, reject;
            let promise = new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
            return { promise, resolve, reject };
        };
    }
}());